import { Ng2StateDeclaration, UIRouterModule } from '@uirouter/angular';
import { Component } from '@angular/core';
import { UiRouterResolverFactory } from '@client/app/shared/ui-router/ui-router-resolver-factory';
import { QualityPagesComponent } from '@client/app/pages/qa/pages/quality-pages.component';
import { QualitySummaryComponent } from '@client/app/pages/qa/summary/quality-summary.component';

@Component({
    selector: 'base-qa',
    template: `<ui-view name="content"></ui-view>`,
    standalone: true,
    imports: [UIRouterModule],
})
class BaseQAComponent {}

export const QA_STATES: Ng2StateDeclaration[] = [
    {
        name: 'base.customer.domain.qa',
        url: '/quality',
        abstract: true,
        views: {
            'content@base.customer.domain': {
                component: BaseQAComponent,
            },
        },
        data: {
            sidebar: 'quality',
        },
        resolve: UiRouterResolverFactory.createActiveFeatureStateResolver({
            token: 'hasAccessQualityFeatures',
            pureFeatures: ['qa_module'],
        }),
    },
    {
        name: 'base.customer.domain.qa.pages',
        url: '/pages',
        views: {
            'content@base.customer.domain.qa': {
                component: QualityPagesComponent,
            },
        },
        data: { title: 'Acquia Web Governance - Content With QA Errors' },
    },
    {
        name: 'base.customer.domain.qa.summary',
        url: '/summary',
        views: {
            'content@base.customer.domain.qa': {
                component: QualitySummaryComponent,
            },
        },
        data: { title: 'Acquia Web Governance - Quality Assurance' },
    },
];
